"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inheritSymbols = exports.addSymbol = exports.getAll = exports.get = exports.hooks = exports.diagnostics = void 0;
const feature_1 = require("./feature");
const plugable_record_1 = require("../helpers/plugable-record");
const deprecation_1 = require("../helpers/deprecation");
const dataKey = plugable_record_1.plugableRecord.key('mappedSymbols');
exports.diagnostics = {
    REDECLARE_SYMBOL(name) {
        return `redeclare symbol "${name}"`;
    },
};
// HOOKS
exports.hooks = (0, feature_1.createFeature)({
    metaInit({ meta }) {
        plugable_record_1.plugableRecord.set(meta.data, dataKey, {});
    },
});
// API
function get(meta, name) {
    const state = plugable_record_1.plugableRecord.getUnsafe(meta.data, dataKey);
    return state[name];
}
exports.get = get;
function getAll(meta) {
    return plugable_record_1.plugableRecord.getUnsafe(meta.data, dataKey);
}
exports.getAll = getAll;
function addSymbol({ context, symbol, node, safeRedeclare = false, localName, }) {
    const stSymbolData = plugable_record_1.plugableRecord.getUnsafe(context.meta.data, dataKey);
    const name = localName || symbol.name;
    const existingSymbol = stSymbolData[name];
    if (existingSymbol && node && !safeRedeclare) {
        context.diagnostics.warn(node, exports.diagnostics.REDECLARE_SYMBOL(name), {
            word: name,
        });
    }
    stSymbolData[name] = symbol;
    // deprecated
    (0, deprecation_1.ignoreDeprecationWarn)(() => {
        context.meta.mappedSymbols[name] = symbol;
    });
}
exports.addSymbol = addSymbol;
function inheritSymbols(originMeta, targetMeta) {
    const originData = plugable_record_1.plugableRecord.getUnsafe(originMeta.data, dataKey);
    plugable_record_1.plugableRecord.set(targetMeta.data, dataKey, Object.create(originData));
}
exports.inheritSymbols = inheritSymbols;
//# sourceMappingURL=st-symbol.js.map